export default __webpack_public_path__ + "static/media/shelf (summer 2010).227966f8.JPG";